import * as React from 'react';
import * as widgets from '@tableau/widgets';
import {
  Configuration,
  MenuEntry,
  MenuItem,
  Point,
  RejectionReason
} from '@tableau/hybrid-widgets-contract';
import { findMenuEntry, menuItemsToWidgetsMenuItems } from '../utils/MenuUtils';

export type ResolveFunc = (selectedEntry: MenuEntry) => void;
export type RejectFunc = (reason: RejectionReason) => void;

export interface MenuComponentProps {
  configuration: Configuration;
  menuItems: Array<MenuItem>;
  resolve: ResolveFunc;
  reject: RejectFunc;
}

const TopLeftAnchorOrigin: widgets.OriginOptions = {
  horizontal: widgets.HorizontalOriginOption.left,
  vertical: widgets.VerticalOriginOption.top,
};

export class MenuComponent extends React.Component<MenuComponentProps> {
  public handleSelect = (val: string): void => {
    const foundEntry = findMenuEntry(val, this.props.menuItems);
    if (foundEntry === null) {
      this.props.reject(RejectionReason.SelectedItemInvalid);
    } else {
      this.props.resolve(foundEntry);
    }
  }

  public handleCancel = (): void => {
    this.props.reject(RejectionReason.NoItemSelected);
  }

  public render(): JSX.Element {
    // tslint:disable:deprecation
    const anchorClientRect: () => ClientRect = () => {
      let offset: Point = this.props.configuration.position.anchorOffset || { x: 0, y: 0 };
      const rect = this.props.configuration.position.anchorElement.getBoundingClientRect();
      return {
        left: rect.left + offset.x,
        top: rect.top + offset.y,
        // assume is single pixel so top/left and bottom/right are the same
        right: rect.left + offset.x,
        bottom: rect.top + offset.y,
        // FIXME is it safe to assume these are unused in Widgets? Does `rect` not provide them anyway?
        width: 0, // unused
        height: 0, // unused
      } as ClientRect;
    };
    // tslint:enable:deprecation

    return (
      <widgets.FlyoutListMenuWidget
        menuItemInfos={menuItemsToWidgetsMenuItems(this.props.menuItems)}
        onSelect={this.handleSelect}
        allowAutoPosition={true}
        requestCloseAll={this.handleCancel}
        testId="hybrid-ui-menu" // FIXME should this not be customizable?
        anchorOrigin={TopLeftAnchorOrigin}
        getAnchorClientRect={anchorClientRect}
        // Must be >= 1000 to to ensure it renders above dialogs which are hardcoded
        // to have zIndexes of 1000. TFSID 690529 tracks getting a global dialog
        // zIndex which we could use here instead of the hard-coded value.
        zIndex={1000}
      />
    );
  }
}
